import { Component, Vue } from "vue-property-decorator";
import { Family } from "../../models";
import { camelToUnderscore } from "../../utils/Typography";

@Component
export default class FamiliesMixin extends Vue {
  readonly path =
    "catalogue/" + camelToUnderscore(Family.type).replace("catalogue_", "");
  readonly routes = this.$getModelRoutes(this.path);

  getFamilies(data: any, tag): Promise<Family[]> {
    return this.$httpGet(this.routes.indexUrl(data), tag);
  }

  getFamily(id: number | string, tag) {
    return this.$httpGet(this.routes.getUrl(id), tag);
  }

  destroyFamily(id, tag) {
    return this.$httpDelete(this.routes.deleteUrl(id), tag, null);
  }

  createFamily(data: any, tag) {
    return this.$httpPost(this.routes.createUrl(), tag, data);
  }

  updateFamily(id: string, data: any, tag) {
    return this.$httpPut(this.routes.updateUrl(id), tag, data);
  }

  detachFile(data: any, tag) {
    return this.$httpDelete(
      this.routes.getUrl(data.id) + "/attachments",
      tag,
      data
    );
  }

  attachFile(familyId: string | number, data: any, tag) {
    return this.$httpPost(
      this.routes.getUrl(familyId) + "/attachments",
      tag,
      data
    );
  }
}
